// @ts-expect-error react-lines-ellipsis does not include type declarations
import LinesEllipsis from 'react-lines-ellipsis';

const SAFE_UNMOUNT_PATCH_FLAG = '__organizerSafeUnmountPatched';

type CanvasNode = {
  parentNode?: {
    removeChild: (node: unknown) => void;
  } | null;
} | null;

type LinesEllipsisPrototype = {
  canvas?: CanvasNode;
  componentWillUnmount?: () => void;
  [SAFE_UNMOUNT_PATCH_FLAG]?: boolean;
};

const linesEllipsisPrototype = (LinesEllipsis as unknown as { prototype?: LinesEllipsisPrototype })
  ?.prototype;

if (
  typeof window !== 'undefined' &&
  linesEllipsisPrototype &&
  !linesEllipsisPrototype[SAFE_UNMOUNT_PATCH_FLAG]
) {
  linesEllipsisPrototype.componentWillUnmount = function safeComponentWillUnmount(
    this: LinesEllipsisPrototype
  ) {
    const canvas = this.canvas;
    if (canvas?.parentNode) {
      canvas.parentNode.removeChild(canvas);
    }
    this.canvas = null;
  };

  linesEllipsisPrototype[SAFE_UNMOUNT_PATCH_FLAG] = true;
}
